<template>
  <div class="container">
    <!-- 头部背景图 -->
    <div class="head-bg"></div>
    <!--头部轮播图-->
    <div class="top" id="top">
      <div class="logo"></div>
      <head-swiper></head-swiper>
    </div>
    <!-- 内容 -->
    <div class="main">
      <!-- 项目介绍 -->
      <introduction>项目介绍</introduction>
      <!-- 项目优势 -->
      <advantage>项目优势</advantage>
      <!-- 真实案例 -->
      <cases>真实案例</cases>
      <!-- 精彩文章 -->
      <articles></articles>
      <!-- 产品中心 -->
      <product></product>
      <!-- 加盟流程 -->
      <join></join>
      <!-- 新零售项目招商 -->
      <business-form></business-form>
      <!-- 二维码 -->
      <qr-card></qr-card>
      <!-- 分享客服 -->
      <suspend @click="suspendClick" v-if="deviceType!=='pc'"></suspend>
      <!-- 分享提示 -->
      <share-mask v-if="shareMaskStatus" @shareHide="shareHide"></share-mask>
    </div>
  </div>
</template>

<script>

import HeadSwiper from '@/components/HeadSwiper.vue'
import Introduction from '@/components/Introduction.vue'
import Advantage from '@/components/Advantage.vue'
import Cases from '@/components/Cases.vue'
import Articles from '@/components/Articles.vue'
import Product from '@/components/Product.vue'
import BusinessForm from '@/components/BusinessForm.vue'
import QrCard from '@/components/QRCard.vue'
import Suspend from '@/components/Suspend.vue'
import Join from '@/components/Join.vue'
import ShareMask from '@/components/ShareMask.vue'

export default {
  name: 'Home',
  components: {
    HeadSwiper,
    Introduction,
    Advantage,
    Cases,
    Articles,
    Product,
    BusinessForm,
    QrCard,
    Suspend,
    Join,
    ShareMask
  },
  data: () => ({
    imgUrl: '',
    // 分享提示状态
    shareMaskStatus: false

  }),
  created () {
    // 微信分享
    this.wxsharePage()
    // app分享
    this.appShareBtn()
  },
  mounted () {
  },
  computed: {

  },
  methods: {
    // 分享提示隐藏
    shareHide (status) {
      this.shareMaskStatus = status
    },
    // 悬浮按钮点击
    suspendClick (type) {
      console.log(type)
      if (type === 'm' || type === 'weixin') {
        this.shareMaskStatus = true
      } else {
        this.onShare()
      }
    }
  }
}
</script>

<style lang="less">
.container {
  width: 100%;
  position: relative;
  .head-bg {
    background: url("https://s.kcimg.cn/topic/images/new-retail/m-bg.jpg")
      no-repeat 50% 50%;
    background-size: cover;
    width: 375px;
    height: 140px;
  }
  .top {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    .logo {
      background: url("https://s.kcimg.cn/topic/images/new-retail/m-logo.png")
        no-repeat 50% 50%;
      background-size: cover;
      width: 75px;
      height: 20px;
      margin: 12px 0;
    }
  }
}

@media screen and (min-width: 376px) {
  .container {
    .head-bg {
      background: url("https://s.kcimg.cn/topic/images/new-retail/pc-bg.jpg")
        no-repeat 50% 50%;
      background-size: cover;
      width: auto;
      max-width: 1920;
      height: 540px;
    }
    .top {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      .logo {
        background: url("https://s.kcimg.cn/topic/images/new-retail/pc-logo.png")
          no-repeat 50% 50%;
        background-size: cover;
        width: 110px;
        height: 30px;
        margin: 20px 0;
      }
    }
  }
}
</style>
